import * as H from 'history';
import  React from 'react';
import { ClaimController } from '../../../../controllers/ClaimController';
import { ClaimModel } from '../../../../models/ClaimModel';
import { Stakeholder } from '../../../../models/Stakeholder';
import { ISupportSpinner } from '../../../../shared/Ajax';
import { Backdrop } from '../../../../shared/Backdrop';
import { Table } from '../../../../shared/table';
import { SaveCancelButtons } from '../../controls/SaveCancelButtons';
import { stakeholderColumns, StakeholderDetails } from './StakeholderDetails';
import { getFY } from '../../../../shared/Utility';



export interface StakeholderPageProps {
    history: H.History
    model: ClaimModel
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
}

export interface StakeholderPageState {
    loading: boolean
    stakeholders: Stakeholder[]
}

export class StakeholderPage extends React.Component<StakeholderPageProps, StakeholderPageState> implements ISupportSpinner {
    ajax: ClaimController
    table: Table<Stakeholder>

    constructor(props: StakeholderPageProps) {
        super(props);

        this.ajax = new ClaimController();

        this.state = {
            loading: false,
            stakeholders: props.model.stakeholders ? props.model.stakeholders.map(r => r) : []
        }
    }

    componentWillUnmount() {
        this.ajax.cancel();
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }

    save = () => {
        this.table.saveAndClose(res => {
            if (res) {
                if (this.state.stakeholders.filter(r => r.invalid).length == 0) {
                    this.props.onChange({ stakeholders: this.state.stakeholders }, () => {
                        this.ajax.updateClaim(this, this.props.model, () => {
                            this.props.history.goBack();
                        })
                    });
                }
                else {
                    alert("Please correct records marked with the warning sign.");
                }
            }
        });
    }

    render() {
        let columns = [...stakeholderColumns];

        var sortedList = this.state.stakeholders.slice();
        sortedList.sort((a, b) => a.invalid ? -1 : 1);

        return <>
            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />
            <h2 className="mt-3">Stakeholders</h2>
            <p className="mt-3 mb-3">Enter the names of company directors or partners in the partnership during {getFY(this.props.model.claimYear)}</p>
            <Table<Stakeholder>
                id="table"
                label="Directors or partners in the partnership"
                ref={r => this.table = r}
                value={sortedList}
                onChange={stakeholders => this.setState({ stakeholders })}
                columns={columns}
                renderSection={(p) => <StakeholderDetails {...p} />}
                match={(a, b) => a.id == b.id}
                allowEdit={true}
                alwaysShowAllRows={true}
            />

            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

            <Backdrop on={this.state.loading} />
        </>
    }
}